var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{attrs:{"center":_vm.center,"zoom":_vm.currentZoom,"options":_vm.mapOptions}},[_c('gmap-marker',{attrs:{"position":_vm.center,"clickable":true,"draggable":true}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6c05e12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/site/js/components/GmapComponent.vue
// module id = 0Sz5
// module chunks = 3